import { CourseData } from "@vixi/types";

export function forEachChapter(
  course: CourseData.Course,
  callback: (chapter: CourseData.Unit, index: number) => void,
) {
  course.chapters?.forEach(callback);
}

export function forEachLesson(
  course: CourseData.Course,
  callback: (lesson: CourseData.Lesson, lessonIndex: number, chapterIndex: number) => void,
) {
  course.chapters?.forEach((unit, chapterIndex) => {
    unit.lessons.forEach((lesson, lessonIndex) => callback(lesson, lessonIndex, chapterIndex));
  });
}
